import { AxiosResponse } from 'axios'
import { useContext } from '@nuxtjs/composition-api'
import { BRAND_MEDIA_ARTICLES, BRAND_MEDIA_ARTICLES_TAGS } from '../../../../config/bitrix-endpoints'
import {
  NewsListResponse,
} from '../../../contracts/api/QueryNews/QueryNews.Response'
import { BITRIX_API } from '../../instance'

export async function getArticlesTags( ctx: ReturnType<useContext> | undefined = undefined, tag: string | undefined, page: number, size: number ): Promise<AxiosResponse<NewsListResponse>> {
  return await BITRIX_API(ctx).get(`${BRAND_MEDIA_ARTICLES_TAGS}?page=${page}&size=${size}${tag ? `&tag=${tag}` : ''}`)
}
